<template>
    <div>
      <div class="form-group">
        <span class="sub-title" :class="{'is-invalid': invalidBust}">Bust size</span>
        <span class="input-error pull-right" v-if="invalidBust">Bust size is required</span>

        <div id="bust-size-container">
          <div class="size-box"
               v-for="(size, index) in bustSizes"
               @click="bust = size"
               :key="`bust-size-${index}`"
               :class="{active: sizeRegion === 'american' && bust === size}">

            <span class="content-centered">{{ size }}</span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <span class="sub-title" :class="{'is-invalid': invalidCup}">Cup size</span>
        <span class="input-error pull-right" v-if="invalidCup">Cup size is required</span>

        <div id="cup-size-container">
          <div class="size-box"
               v-for="(size, index) in cupSizes"
               @click="cup = size"
               :key="`cup-size-${index}`"
               :class="{active: sizeRegion === 'american' && cup === size}">

            <span class="content-centered">{{ size }}</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
  name: "BraAmericanSizes",

  props: ['invalidBust', 'invalidCup'],

  data() {
    return {
      bustSizes: [28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54],
      cupSizes: ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'G', 'H', 'I'],
    };
  },

  computed: {
    ...mapFields('userSelections', [
      'female.bra.sizeRegion',
      'female.bra.bust',
      'female.bra.cup',
    ]),
  },
};
</script>
